import { useNavigate, useSearchParams } from "react-router-dom";
import { BookOpen, Layers } from "lucide-react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import ManualLibrary from "./ManualLibrary";
import ExplodedViewsTab from "@/components/repair-guides/ExplodedViewsTab";
import { SettingsBackLink } from "@/components/settings/SettingsBackLink";

/**
 * Repair Guide Center — combines the existing Manuals library with the new
 * Exploded Views library in a single tabbed page.
 */
export default function RepairGuideCenter() {
  const navigate = useNavigate();
  const [params, setParams] = useSearchParams();
  const tab = params.get("tab") === "exploded" ? "exploded" : "manuals";

  return (
    <div className="min-h-screen bg-background pb-24">
      <div className="px-6 pt-6 pb-4">
        <SettingsBackLink to="/settings/data" label="Data Management" />

        <h1 className="text-2xl font-bold text-foreground">Repair Guide Center</h1>
        <p className="text-muted-foreground">
          Manuals and exploded-view diagrams that surface inside repair, refurbishment and harvesting workflows.
        </p>
      </div>

      <Tabs
        value={tab}
        onValueChange={(v) => setParams({ tab: v }, { replace: true })}
        className="px-6"
      >
        <TabsList className="mb-4">
          <TabsTrigger value="manuals" className="gap-2">
            <BookOpen className="w-4 h-4" /> Manuals
          </TabsTrigger>
          <TabsTrigger value="exploded" className="gap-2">
            <Layers className="w-4 h-4" /> Exploded Views
          </TabsTrigger>
        </TabsList>

        <TabsContent value="manuals" className="mt-0">
          {/* The manual library renders its own header + back button.
              We render it without the outer wrapper by mounting the page directly. */}
          <ManualLibrary embedded />
        </TabsContent>
        <TabsContent value="exploded" className="mt-0">
          <ExplodedViewsTab />
        </TabsContent>
      </Tabs>
    </div>
  );
}
